import $ from 'jquery';
import Alert from './alert'

var Watchlist = {
  // finds any elements with class, then binds them to the toggle function
  bind: function() {
    $('.watchlist-btn')
      .off('click')
      .on('click', this.toggle);
  },

  // Adds or removes car from watchlist
  toggle: function(e) {
    e.preventDefault();

    var self      = $(this),
        id        = self.parent().data('id'),
        row       = $('.result_' + id),
        addEl     = $('.watchlist-buttons[data-id=' + id + ']').find('.add'),
        deleteEl  = $('.watchlist-buttons[data-id=' + id + ']').find('.delete'),
        data      = {
          'id': id
        },
        action    = 'add';

    Watchlist.showLoading(self);

    if ( self.hasClass("delete") ) {
      action = 'remove';
      data['HTTP_X_HTTP_METHOD_OVERRIDE'] = 'DELETE';
    }

    $.ajax({
      'method'    : 'POST',
      'url'       : self.attr('href'),
      'dataType'  : 'json',
      'data'      : data
    })
    .done(function(response) {
      Alert.show({
        level: 'success',
        message: response.message
      });

      switch (action) {
        case 'add':
          row.addClass('watchlisted');
          addEl.addClass("hidden");
          deleteEl.removeClass("hidden");
          break;
        case 'remove':
          row.removeClass('watchlisted');
          addEl.removeClass("hidden");
          deleteEl.addClass("hidden");
          break;
      }

      Watchlist.hideLoading(self);
    })
    .fail(function(response) {
      Alert.show({
        level: 'danger',
        message: response.message
      });

      Watchlist.hideLoading(self);
    });
  },

  showLoading: function(el) {
    el.append('<span class="btn-loading"><i class="fa fa-spinner"></i></span>');
  },

  hideLoading: function(el) {
    el.find('.btn-loading').remove();
  }
};

export default Watchlist;



// WEBPACK FOOTER //
// ./app/webroot/javascript/modules/watchlist.js